import { EventTranslate } from './eventTranslate.model';

const eventTranslateEN: EventTranslate = {
  page: {
    title: 'Event board',
  },
  card: {
    title: 'Event',
    date: 'Date',
    time: 'Time',
    edit: 'Edit',
    addTodo: 'New task',
    duplicate: 'Duplicate',
    location: 'Location',
    options: {
      edit: 'Edit',
      delete: 'Delete event',
      move: 'Move to…',
    },
  },
  column: {
    dropHere: 'Drop here',
    dragHere: 'Drag here',
    addColumn: 'Add column',
    newColumnName: 'Column name',
    create: 'Create',
    cancel: 'Cancel',
    archive: 'Archive',
    archiveConfirmTitle: 'Archive column',
    archiveConfirmEmpty: 'Are you sure you want to archive this column?',
    archiveConfirmWithEvents:
      'This column has {{count}} event(s). Archiving it will also archive all events associated with it. Do you want to continue?',
    archiveConfirmButton: 'Archive',
    archiveCancelButton: 'Cancel',
    rename: 'Rename',
    renamePlaceholder: 'New column name',
    renameSubmit: 'Save',
    renameError: 'Failed to rename column',
  },
  archivedModal: {
    title: 'Archived columns',
    openButton: 'Open archived columns',
    empty: 'No archived columns',
    restoreButton: 'Restore',
    archivedAt: 'Archived at',
    restoreSuccess: 'Column restored successfully',
    restoreError: 'Failed to restore column',
  },
  moveModal: {
    title: 'Move event',
    description: 'Pick the destination column',
    currentLabel: 'Current',
    empty: 'No other column available',
    success: 'Event moved',
    error: 'Failed to move event',
  },
  widget: {
    title: 'Upcoming events',
    viewAll: 'View all',
    empty: 'No events in the next 7 days',
    addNew: 'New event',
  },
  imageConsent: {
    field: 'Image usage consent',
    recordOnlyHint:
      'This field is a record for you to check. It does not block the gallery or prevent publishing.',
    label: 'Image usage',
    option: {
      NOT_ASKED: 'Not asked',
      GRANTED: 'Can post',
      DENIED: 'Cannot post',
    },
    badge: {
      NOT_ASKED: 'Image usage not asked',
      GRANTED: 'Can post',
      DENIED: 'Cannot post',
    },
    notice: {
      deniedTitle: 'Cannot post',
      deniedDescription:
        'The client did not authorize the use of images from this session. Do not publish these photos on social media, website or portfolio.',
      grantedTitle: 'Image usage authorized for this session',
      leadDeniedTitle: 'This client denied image usage in another session',
      leadDeniedDescription:
        'The consent for this gallery has not been recorded yet. Confirm with the client before publishing these photos.',
      notAskedTitle: 'Image usage consent not asked',
      notAskedDescription:
        'Record on the event whether the client authorizes the use of images from this session.',
      noEventTitle: 'Gallery without a linked session',
      noEventDescription:
        'Link this gallery to an event to track the image usage consent.',
    },
  },
};

export default eventTranslateEN;
